import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { IScheduler } from './types'
import { SmallPanel } from './SmallPanel'
import { IoCalendarOutline } from 'react-icons/io5';
import { themedUseStyletron } from '../../../theme/customTheme';

export function OverviewPanel(props: IScheduler) {
    const [, theme] = themedUseStyletron();
    
    return (
        <OverviewPanelWrapper  height={theme.appSizes.xSmallAppHeight}  icon={<IoCalendarOutline size={'100%'}  color={theme.colors.backgroundPrimary}></IoCalendarOutline>} small {...props}>
            <SmallPanel {...props}></SmallPanel>
        </OverviewPanelWrapper>
    );
}
